import ApprovedRequestNotification from './ApprovedRequestNotification.jsx';
import PendingRequestNotification from './PendingRequestNotification.jsx';

const Notifications = () => {
  return (
    <div className="grid max-w-145 gap-4">
      <PendingRequestNotification />
      <ApprovedRequestNotification />
    </div>
  );
};

export default Notifications;
